export const GACHA_KEYS = {
  PITY_GAUGE: 'gacha/pity-gauge',
  RECENT_WINNERS: 'gacha/recent-winners',
  HISTORY: 'gacha/history',
} as const
